import { ROUTE_CONFIG } from "@/routes/config";

import { RECONNECT_LINKEDIN_PARAM, RECONNECT_LINKEDIN_VALUE } from "./components/LinkedinLogin";
import { AccountTabs } from "./accountTabs";

/**
 * Deep-link to the LinkedIn card with its connect/reconnect flow auto-opened. `LinkedinLogin`
 * picks connect vs reconnect from the account state: never-connected → connect,
 * previously-connected-now-logged-out (or only Sales Navigator dropped, where the base account
 * stays logged in) → reconnect.
 *
 * The tab is named explicitly so the link switches to it even when the user is already on the
 * Account page on another tab — inactive tabs are unmounted, so without it the LinkedIn card never
 * re-mounts to read the reconnect param.
 *
 * Every "connect LinkedIn" call-to-action must use this — a bare `ROUTE_CONFIG.ACCOUNT` lands on
 * the General tab, which reads as the button doing nothing (PREC-3805).
 */
export const RECONNECT_LINKEDIN_DEEP_LINK = `${ROUTE_CONFIG.ACCOUNT}?tab=${AccountTabs.CONNECTED_ACCOUNTS}&${RECONNECT_LINKEDIN_PARAM}=${RECONNECT_LINKEDIN_VALUE}`;
